<h2 class="mbottom-12">{{ 'commercialCommon.billingAddressSelectionCommon.selectBillingAddress' | transloco }}</h2>
<div class="row mbottom-12">
  <div class="col-12">
    <yat-no-billing-address id="f414420c-06cc-4d04-adf9-d4de4b78a01a" [isActive]="selectedId === null" (selected)="select(null)"> </yat-no-billing-address>
  </div>
</div>
<div *ngFor="let billingAddress of billingAddresses$ | async; let i = index; trackBy: trackBillingAddress" class="row mbottom-12">
  <div class="col-12">
    <yat-billing-address-panel
      [id]="'4d894839-e1b3-46f3-a445-e4f438526439-' + i"
      [billingAddress]="billingAddress"
      [defaultIcon]="billingAddress.id === selectedId ? 'selected' : null"
      [showDeleteIcon]="(billingAddress | isPaymentMethodOrBillingAddressDeletable: updateSubscriptionWithContractId) && !billingAddress.readOnly"
      [showEditIcon]="(billingAddress | isPaymentMethodOrBillingAddressEditable: updateSubscriptionWithContractId) && !billingAddress.readOnly"
      [liveLicense]="(isLive$ | async) ?? true"
      (selectAddress)="select(billingAddress.id, $event)"
      (prepareDeleteAddress)="prepareDelete(billingAddress.id)"
      (cancelDeleteAddress)="cancelDelete()"
      (deleteAddress)="delete(billingAddress.id, $event)"
      (editMethod)="editSelectedBillingAddress(billingAddress)"
      (modalClosed)="modalClosed()"
      [sameBillingAddressSelected]="(sameBillingAddressSelected$ | async) ?? true"
      [matomoEventClickAction]="billingAddress.id === selectedId ? '' : 'Select_BillingAddress'">
      >
    </yat-billing-address-panel>
  </div>
</div>
<div>
  <a
    yat-link
    class="link link-secondary"
    routerLink="../billing-address"
    [matomoClickCategory]="MATOMO_EVENT_CATEGORY_BILLING"
    matomoClickAction="Submit_AdditionalBillingAddress"
    ><yat-icon id="e4f816cc-5055-4730-817e-1df56bb3307c" name="plus-circle-duo" class="mr-1"></yat-icon>{{ 'commercialCommon.billingAddressSelectionCommon.addNewBillingAddress' | transloco }}</a
  >
</div>
<div class="row mt-4">
  <div class="col-12">
    <button
      yat-button
      type="button"
      class="btn btn-large primary w-100"
      (click)="continue()"
      [matomoClickCategory]="MATOMO_EVENT_CATEGORY_BILLING"
      matomoClickAction="Select_BillingAddress"
      matomoClickName="Continue">
      {{ 'continue' | commonWording | async }}
    </button>
  </div>
</div>
